/* ==========================================================================
   KINOVA — SARLAVHA: QIDIRUV VA PROFIL MENYUSI (07.10.2026)
   ==========================================================================
   Foydalanuvchi talabi:
     • "poisk faqat logotipi chiqadi, bosganda effekt bilan shaffof
        bo'lib chiqsin";
     • "foydalanuvchi ismi umuman chiqmasligi kerak, faqat profil
        avatar bilan; avatarni bosganda profilni ko'rish, sozlanmalar
        va chiqish bo'lsin".

   ⚠️ NIMA UCHUN ALOHIDA FAYL: `resources/js/main.js` dizayn manbasidan
      ajratilgan fayl (unga tegish `scripts/extract-assets.mjs` dagi
      ISTISNO ro'yxatini kengaytirishni talab qiladi). Yangi xatti-harakat
      shu yerda — mustaqil, kichik va tushunarli.

   ⚠️ SARLAVHA JS BILAN QO'YILADI (`main.js` → injectChrome()), shuning
      uchun elementlar DARHOL mavjud bo'lmasligi mumkin. Shu sababli
      hodisalar HUJJATGA bog'lanadi (delegatsiya) — qachon qo'yilsa
      ham ishlaydi, hech narsani kutib o'tirmaydi.

   ⚠️ JS o'chiq bo'lsa sayt BUZILMAYDI: qidiruv formasi oddiy
      `GET /search` formasi bo'lib qolaveradi, menyu bandlari esa
      oddiy havolalar.
   ========================================================================== */
(function (global) {
  'use strict';

  var OPEN = 'is-open';

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentNode;
    }

    return null;
  }

  /* ── Profil menyusi ───────────────────────────────────────────────── */
  function menuEls() {
    return {
      wrap: document.getElementById('headerUser'),
      btn: document.getElementById('headerUserBtn'),
      menu: document.getElementById('headerMenu'),
    };
  }

  function closeMenu() {
    var e = menuEls();
    if (!e.menu || e.menu.hidden) return;

    e.menu.hidden = true;
    e.wrap.classList.remove(OPEN);
    e.btn.setAttribute('aria-expanded', 'false');
  }

  function openMenu() {
    var e = menuEls();
    if (!e.menu) return;

    closeSearch();
    e.menu.hidden = false;
    e.wrap.classList.add(OPEN);
    e.btn.setAttribute('aria-expanded', 'true');

    // Birinchi band — klaviatura bilan ham ishlasin.
    var first = e.menu.querySelector('.header-menu__item');
    if (first && first.focus) first.focus();
  }

  /* ── Qidiruv ──────────────────────────────────────────────────────── */
  function searchEls() {
    return {
      form: document.getElementById('headerSearch'),
      input: document.getElementById('headerSearchInput'),
      toggle: document.getElementById('headerSearchToggle'),
    };
  }

  function closeSearch() {
    var e = searchEls();
    if (!e.form || !e.form.classList.contains(OPEN)) return;

    e.form.classList.remove(OPEN);
    e.toggle.setAttribute('aria-expanded', 'false');
    // Yopiq maydon klaviatura bilan tanlanmasin (ko'rinmaydi-ku).
    e.input.setAttribute('tabindex', '-1');
  }

  function openSearch() {
    var e = searchEls();
    if (!e.form) return;

    closeMenu();
    e.form.classList.add(OPEN);
    e.toggle.setAttribute('aria-expanded', 'true');
    e.input.removeAttribute('tabindex');
    e.input.focus();
  }

  /* ── Hodisalar (hujjat darajasida — delegatsiya) ──────────────────── */
  document.addEventListener('click', function (ev) {
    var toggle = closest(ev.target, '#headerSearchToggle');

    if (toggle) {
      ev.preventDefault();
      var se = searchEls();

      if (!se.form.classList.contains(OPEN)) { openSearch(); return; }

      // Ochiq va matn yozilgan — tugma endi QIDIRADI (o'lik tugma yo'q).
      if ((se.input.value || '').trim() !== '') { se.form.submit(); return; }

      closeSearch();

      return;
    }

    if (closest(ev.target, '#headerUserBtn')) {
      ev.preventDefault();
      var me = menuEls();

      if (me.menu.hidden) openMenu();
      else closeMenu();

      return;
    }

    // Tashqariga bosilsa — ikkalasi ham yopiladi.
    if (!closest(ev.target, '#headerMenu')) closeMenu();
    if (!closest(ev.target, '#headerSearch')) closeSearch();
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;

    var se = searchEls();
    var open = se.form && se.form.classList.contains(OPEN);

    closeMenu();
    closeSearch();

    // Qidiruv yopilganda fokus lupa belgisida qolsin.
    if (open && se.toggle) se.toggle.focus();
  });

  /* Sahifa o'lchami o'zgarsa (telefon ko'rinishiga o'tsa) — yopiladi. */
  global.addEventListener('resize', function () { closeMenu(); closeSearch(); }, { passive: true });
})(window);
